import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-incomes',
  templateUrl: './incomes.component.html',
  styleUrls: ['./incomes.component.css'],
})
export class IncomesComponent implements OnInit {
  @Input() formStep: FormGroup;

  constructor() {}

  ngOnInit(): void {
    this.formStep.valueChanges.subscribe((data) => {
      let totalIncome = 0;
      for (let v in this.formStep.value) {
        if (v !== 'TotalInkomst') {
          if (this.formStep.value[v] === '') {
            this.formStep.get(v).setValue(null, { emitValue: false });
          }

          totalIncome += Number(this.formStep.value[v]);
        }
      }
      (this.formStep.get('TotalInkomst') as FormControl).setValue(totalIncome, {
        emitEvent: false,
      });
    });
  }
}
